define.alias("shared/components/shared/schedule-navbar", "preview-grid/components/shared/schedule-navbar");